import React from 'react';
import { LabelName } from '../../index';
import { format } from 'date-fns';
import ReadingTimeIcon from '../../../../assets/svgs/reading-time.svg';
import SocialLinks from '../social-icons';

const Header = ({
  title,
  date,
  issueName,
  postImage,
  isSpotlight,
  articleReadingTime,
  categoryName,
  postAuthors,
  simpleEmailShareUrl,
  simpleTwitterShareUrl,
  simpleMatterShareUrl,
  handleCopyClick,
  isCopied,
}) => {
  return (
    <header
      className={`single-article__header-wrapper article-header ${
        postImage && `article-header--featured-image`
      }`}
    >
      {(issueName || isSpotlight || categoryName) && (
        <div className="article-header__category">
          <div className="intro-titles">
            {issueName && <div className="intro-titles__label">{issueName}</div>}
            {(isSpotlight || categoryName) && (
              <div className="intro-titles__name">
                {isSpotlight ? `Spotlight Article` : categoryName}
              </div>
            )}
          </div>
        </div>
      )}
      <div className="article-header__head">
        <div className="article-header__head-inner">
          {postAuthors.length > 0 && (
            <LabelName
              label="Words by"
              names={postAuthors}
              className="article-header__head-label"
            />
          )}
          <h1 className="article-header__head-title">{title}</h1>
          <div className="article-header__head-date">{format(new Date(date), 'do MMMM yyyy')}</div>
          <SocialLinks
            classname="article-header__head-social-media"
            simpleTwitterShareUrl={simpleTwitterShareUrl}
            simpleMatterShareUrl={simpleMatterShareUrl}
            simpleEmailShareUrl={simpleEmailShareUrl}
            handleCopyClick={handleCopyClick}
            isCopied={isCopied}
          />
          <div className="article-header__head-separator" />
          {articleReadingTime && (
            <div className="article-header__head-reading-time">
              {articleReadingTime} Mins <ReadingTimeIcon />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
